export default () => {
  const s = {}
  const init = () => {
    s.scrollAreas = document.querySelectorAll('.at-grade-table');
    if (!s.scrollAreas.length) {
      return
    }

    // 表示内容はAPIからのデータを表示するため、処理後に発火させるため関数を登録
    // トリガーを発火させるファイルは左記のファイル：/assets/scripts/data/athletes_player.js
    document.body.buildGradeTables = buildGradeTables;
  }

  const buildGradeTables = () => {
    s.scrollAreas.forEach(scrollArea => {
      buildScrollBar(scrollArea);
      buildAccordion(scrollArea);
    });
  }

  const buildScrollBar = (contentRoot) => {
    const scrollArea = contentRoot;
    const rail = contentRoot.querySelector('.at-grade-table-scrollbar__rail');
    const thumb = contentRoot.querySelector('.at-grade-table-scrollbar__thumb');

    scrollArea.addEventListener('scroll', (evt) => {
      const rate = evt.target.scrollLeft / (evt.target.scrollWidth - scrollArea.clientWidth)
      const setTranslateX = (rail.clientWidth - thumb.clientWidth) * rate
      thumb.style.transform = `translateX(${setTranslateX}px)`
    }, false)
  }

  const buildAccordion = (contentRoot) => {
    const handle = contentRoot.querySelector('.at-grade-table__handle');
    if (!handle) {
      return;
    }

    const hitArea = handle.querySelector('.at-grade-table__handle-target');
    const accordionBody = contentRoot.querySelector('.at-grade-table__body._hidden');
    if (!accordionBody) {
      handle.classList.add('_hidden');
      return;
    }

    hitArea.addEventListener('click', (e) => {
      e.preventDefault();
      contentRoot.classList.toggle('is-open');
      const isOpen = contentRoot.classList.contains('is-open');
      if (isOpen) {
        accordionBody.setAttribute('aria-hidden', false);
        accordionBody.style.height = `${accordionBody.firstElementChild.clientHeight * accordionBody.childElementCount}px`;
      } else {
        accordionBody.setAttribute('aria-hidden', true);
        accordionBody.style.height = '';
      }
    })
  }

  init();
}
